export const BRIEF_TONE = {
  feminine: 'feminine',
  neutral: 'neutral',
  masculine: 'masculine',
};

const BRIEF_TONE_LABEL = {
  [BRIEF_TONE.feminine]: 'Female',
  [BRIEF_TONE.neutral]: 'Neutral',
  [BRIEF_TONE.masculine]: 'Male',
};

export const getBriefToneLabel = (tone) => BRIEF_TONE_LABEL[tone] || '';

export const defaultBriefSettings = () => ({
  tone: BRIEF_TONE.neutral,
  minAge: null,
  maxAge: null,
});

export const mapSettingsForEditing = (brief) => ({
  tone: brief.tone || BRIEF_TONE.neutral,
  minAge: brief.minAge,
  maxAge: brief.maxAge,
});
